import { render } from "./envelopesDetail.vue?vue&type=template&id=1775723e&scoped=true"
import script from "./envelopesDetail.vue?vue&type=script&lang=js"
export * from "./envelopesDetail.vue?vue&type=script&lang=js"

import "./envelopesDetail.vue?vue&type=style&index=0&id=1775723e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1775723e"]])

export default __exports__